<template>
  <div
    class="filter-btn h-9 w-full text-left px-4 flex items-center justify-between"
    :class="{ 'bg-line/[0.1]': props.withBackground }"
  >
    <div class="flex items-center gap-4">
      <Checkbox
        v-if="props.withCheckbox"
        :model-value="props.modelValue"
        @update:model-value="emit('update:modelValue', $event)"
      />
      <slot />
    </div>
    <Btn
      v-if="props.withButton"
      class="mr-2"
      :size="BtnSize.SM"
      icon
      @click="$emit('chooseFilter')"
    >
      <Icon :icon="ArrowRightSvg" />
    </Btn>
  </div>
</template>

<script setup lang="ts">
import { Btn, BtnSize } from '~/components/btn';
import { Icon } from '~/components/icon';
import ArrowRightSvg from '~/assets/icons/arrow-right.svg?component';
import { Checkbox } from '~/components/inputs/checkbox';

type Props = {
  modelValue?: boolean;
  withBackground?: boolean;
  withButton?: boolean;
  withCheckbox?: boolean;
};
const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue', 'chooseFilter']);
</script>
